import React from 'react';

function stringSanitizer(string) {
  // Remove any symbols and special characters.
  return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9-]+/g, '-')
    .replace(/[ -]+/g, '-');
}

export default stringSanitizer;
